import React, { Component } from 'react'
import {
  Input,
  Button,
  Icon,
  RegulationDefaultComponent,
  RegulationIuppComponent,
  TermsDefaultComponent,
  TermsIuppComponent,
  PrivacyDefaultComponent,
  PrivacyIuppComponent
} from 'loyal-react'
import Layout from '../Layout'
import PasswordStrength from '../PasswordStrength/PasswordStrength'
import AmazonCognitoAdvancedSecurityData from '../../services/amazonCognito'
import ValidationRules from '../../validation/validationRules'
import MediaQuery from 'react-responsive'
import yn from 'yn'
import Helmet from 'react-helmet'
class ChangePasswordPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      usernamePolicy: `${process.env.RAZZLE_USERNAME_POLICY}`,
      login: '',
      password: '',
      confirmPassword: '',
      cognitoAsfData: '',
      showRegulation: false,
      showTerms: false,
      showPrivacy: false
    }
  }

  handleChange = ({ target: { name, value } }) => this.setState({ [name]: value, error: undefined })

  handleSubmit = (event, isValid) => {
    if (!isValid) {
      event.preventDefault()
      return
    }
    if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') {
      return true
    }

    var asfData = AmazonCognitoAdvancedSecurityData.getData('', '', this.clientId)

    if (typeof asfData === 'undefined') {
      return true
    }

    this.setState({ cognitoAsfData: asfData })
    return true
  }

  get clientId() {
    const search = this.props.location.search
    const params = new URLSearchParams(search)
    return params.get('client_id')
  }

  showRegulation = () => {
    this.setState({
      showRegulation: true,
      showTerms: false,
      showPrivacy: false
    })

    var modalRegulation = document.getElementById('modal-regulamento')
    modalRegulation.focus()
  }

  showTerms = () => {
    this.setState({
      showRegulation: false,
      showTerms: true,
      showPrivacy: false
    })

    var modalTerms = document.getElementById('modal-termos')
    modalTerms.focus()
  }

  showPrivacy = () => {
    this.setState({
      showRegulation: false,
      showTerms: false,
      showPrivacy: true
    })

    var modalPrivacy = document.getElementById('modal-privacidade')
    modalPrivacy.focus()
  }

  hideModal = () => {
    this.setState({
      showRegulation: false,
      showTerms: false,
      showPrivacy: false
    })
  }

  validatePassword = (isPasswordsMatch) => {
    this.setState({
      error: this.state.confirmPassword && !isPasswordsMatch ? false : undefined
    })
  }

  render() {
    const rules = ValidationRules.rulesPass
    var isPasswordsMatch = this.state.confirmPassword === this.state.password
    var isValid =
      this.state.password &&
      ValidationRules.testRules(rules)(this.state.password) &&
      this.state.confirmPassword &&
      this.state.password === this.state.confirmPassword
    return (
      <>
        <Layout>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Cadastrar senha`}</title>
          </Helmet>
          <div id="box-newPassword" className="box-login box-newPassword row pb-0">
            <form method="post" className="col-12" onSubmit={(event) => this.handleSubmit(event, isValid)}>
              <div className="col-12 col-md-6 col-lg-5 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5">
                <div className="row">
                  <div className="col-12">
                    <h1 className="h1 login-title color-brand-1 txt-font-body mb-1">
                      {`Agora, crie a senha que será usada aqui no ${
                        process.env.RAZZLE_MESSAGE_NAME || process.env.RAZZLE_TITLE
                      }...`}
                    </h1>
                    <div className="row">
                      <input type="hidden" name="cognitoAsfData" value={this.state.cognitoAsfData} />
                      <Input
                        id="password"
                        label="nova senha"
                        className="col-12 col-md-12 mt-1"
                        name="password"
                        value={this.state.password}
                        onChange={this.handleChange}
                        type="password"
                      />
                      <Input
                        id="confirmPassword"
                        label="repete pra gente ter certeza"
                        className="col-12 col-md-12 mt-2"
                        name="confirmPassword"
                        value={this.state.confirmPassword}
                        onChange={this.handleChange}
                        onBlur={() => this.validatePassword(isPasswordsMatch)}
                        type="password"
                        valid={this.state.error}
                        data-error="As senhas digitadas não conferem"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <PasswordStrength password={this.state.password} />
                  </div>
                </div>
                <div className="col-12 col-md-12 txt-center mt-2 px-0">
                  <div className="col-12 col-md-12 txt-center mt-2 mb-2 px-0">
                    <div className="row align-items-center h-100">
                      <p className="col txt-left">
                        <MediaQuery maxDeviceWidth={420}>
                          Ao criar sua conta, você concorda com os{' '}
                          <span
                            className="color-brand-2 txt-underline"
                            title="Abre em uma nova janela termos de uso"
                            tabIndex={0}
                            onClick={() => this.showTerms()}
                            onKeyPress={() => this.showTerms()}
                          >
                            termos de uso,
                          </span>{' '}
                          <span
                            className="color-brand-2 txt-underline"
                            title="Abre em uma nova janela de regulamento"
                            tabIndex={0}
                            onClick={() => this.showRegulation()}
                            onKeyPress={() => this.showRegulation()}
                          >
                            regulamento
                          </span>{' '}
                          e{' '}
                          <span
                            className="color-brand-2 txt-underline"
                            title="Abre em uma nova janela política de privacidade"
                            tabIndex={0}
                            onClick={() => this.showPrivacy()}
                            onKeyPress={() => this.showPrivacy()}
                          >
                            política de privacidade
                          </span>
                          &nbsp;{`do ${process.env.RAZZLE_MESSAGE_NAME || process.env.RAZZLE_TITLE}.`}
                        </MediaQuery>
                        <MediaQuery minDeviceWidth={421}>
                          Ao criar sua conta, você concorda com os{' '}
                          <a
                            href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/terms`}
                            target="_blank"
                            className="color-brand-2 txt-underline"
                            tabIndex={0}
                            title="Abre em uma nova janela termos de uso"
                          >
                            termos de uso,
                          </a>{' '}
                          <a
                            href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/regulation`}
                            target="_blank"
                            className=" color-brand-2 txt-underline"
                            tabIndex={0}
                            title="Abre em uma nova janela de regulamento"
                          >
                            regulamento
                          </a>{' '}
                          e{' '}
                          <a
                            href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/privacy`}
                            target="_blank"
                            className=" color-brand-2 txt-underline"
                            tabIndex={0}
                            title="Abre em uma nova janela política de privacidade"
                          >
                            política de privacidade
                          </a>
                          &nbsp;{`do ${process.env.RAZZLE_MESSAGE_NAME || process.env.RAZZLE_TITLE}.`}
                        </MediaQuery>
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 txt-center mt-2 px-0">
                    <div className="hide-absolute" aria-live="polite" role="status" aria-atomic="true">
                      {!isValid &&
                        this.state.confirmPassword !== '' &&
                        this.state.password !== '' &&
                        'Sua senha não é válida.'}
                      {isValid && 'Por favor, clique no botão para salvar e finalizar.'}
                    </div>
                    <button
                      name="reset_password"
                      // disabled={!isValid}
                      aria-disabled={!isValid}
                      role="button"
                      type="submit"
                      className={`btn btn-sm btn-featured ${!isValid && 'btn-disabled'}`}
                      value="salvar e finalizar"
                      aria-label="salvar e finalizar"
                    >
                      salvar e finalizar
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div
            id="modal-regulamento"
            tabIndex={0}
            role="modal-regulamento"
            aria-labelledby="modal-regulamento"
            className={`pos-fixed t-0 l-0 px-1 bg-white row h-100 ${this.state.showRegulation ? '' : 'd-none'}`}
          >
            <div className="col-12">
              <p className="txt-body-sm">
                <div
                  className="txt-body-sm"
                  onClick={() => this.hideModal()}
                  aria-label="Voltar"
                  role="button"
                  tabIndex={0}
                >
                  <Icon className="icon icon_left_app txt-body-lg" />
                </div>
              </p>
            </div>
            <div className="col-12" style={{ overflowY: 'auto', height: 'calc(100% - 130px)' }}>
              {yn(process.env.RAZZLE_HAS_REGULATION_CUSTOM) ? (
                <RegulationIuppComponent />
              ) : (
                <RegulationDefaultComponent />
              )}
            </div>
            <div className="col-12 my-2">
              <Button
                className="btn btn-sm btn-featured"
                type="button"
                text="Concordo com o regulamento"
                onClick={() => this.hideModal()}
              />
            </div>
          </div>
          <div
            id="modal-termos"
            tabIndex={0}
            role="modal-termos"
            aria-labelledby="modal-termos"
            className={`pos-fixed t-0 l-0 px-1 bg-white row h-100 ${this.state.showTerms ? '' : 'd-none'}`}
          >
            <div className="col-12">
              <p className="txt-body-sm">
                <div
                  className="txt-body-sm"
                  onClick={() => this.hideModal()}
                  aria-label="Voltar"
                  role="button"
                  tabIndex={0}
                >
                  <Icon className="icon icon_left_app txt-body-lg" />
                </div>
              </p>
            </div>
            <div className="col-12" style={{ overflowY: 'auto', height: 'calc(100% - 130px)' }}>
              {yn(process.env.RAZZLE_HAS_TERMS_CUSTOM) ? <TermsIuppComponent /> : <TermsDefaultComponent />}
            </div>
            <div className="col-12 my-2">
              <Button
                className="btn btn-sm btn-featured"
                type="button"
                text="Concordo com os termos"
                onClick={() => this.hideModal()}
              />
            </div>
          </div>
          <div
            id="modal-privacidade"
            tabIndex={0}
            role="modal-privacidade"
            aria-labelledby="modal-privacidade"
            className={`pos-fixed t-0 l-0 px-1 bg-white row h-100 ${this.state.showPrivacy ? '' : 'd-none'}`}
          >
            <div className="col-12">
              <p className="txt-body-sm">
                <div
                  className="txt-body-sm"
                  onClick={() => this.hideModal()}
                  aria-label="Voltar"
                  role="button"
                  tabIndex={0}
                >
                  <Icon className="icon icon_left_app txt-body-lg" />
                </div>
              </p>
            </div>
            <div className="col-12" style={{ overflowY: 'auto', height: 'calc(100% - 130px)' }}>
              {yn(process.env.RAZZLE_HAS_PRIVACY_CUSTOM) ? <PrivacyIuppComponent /> : <PrivacyDefaultComponent />}
            </div>
            <div className="col-12 my-2">
              <Button
                className="btn btn-sm btn-featured"
                type="button"
                text="Concordo com a política de privacidade"
                onClick={() => this.hideModal()}
              />
            </div>
          </div>
        </Layout>
      </>
    )
  }
}

export default ChangePasswordPage
